export default __webpack_public_path__ + "static/media/AimaObriango.a4740dcf.jpg";